import { PageHeader } from 'restaurantAdmin/layout/PageHeader';
import { OPERATIONS_LISTINGS_CREATE_PATH } from 'restaurantAdmin/paths';
import { ButtonVariants } from '@components/button/Button';
import { LinkStyledAsButton } from '@components/linkStyledAsButton/LinkStyledAsButton';
import { useLocation } from 'react-router-dom';

export const ListingsPageHeader = () => {
  const { pathname } = useLocation();

  return (
    <PageHeader category="Operations" title="Listings">
      <LinkStyledAsButton
        variant={ButtonVariants.Secondary}
        to={OPERATIONS_LISTINGS_CREATE_PATH}
        label="Create Listing"
        state={{
          referrer: pathname,
        }}
      />
    </PageHeader>
  );
};
